/**
 * Custom hook for managing policies
 */
import { useState, useCallback } from 'react';
import { fetchAllPolicies } from '../services/policyService';

export const usePolicies = () => {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fetch all policies
   */
  const fetchPolicies = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchAllPolicies();
      if (response && response.policies) {
        setPolicies(response.policies);
      } else {
        setPolicies([]);
      }
    } catch (err) {setError(err.message || 'Failed to load policies');
      setPolicies([]);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    policies,
    setPolicies,
    loading,
    error,
    fetchPolicies,
  };
};

